import {Radio as HUIRadio} from '@headlessui/react'

import {twMerge} from '@sdox/utils'

export type RadioProps = {
  value: string | null
  label: string
}

export const Radio = ({value, label}: RadioProps) => (
  <HUIRadio
    value={value}
    className={'focus-visible:outline-none'}
  >
    {({focus, checked}) => {
      let borderClasses = 'border-gray-300 bg-white'

      if (checked) borderClasses = 'bg-interactive-surface-filled-brand-default border-transparent'
      if (focus) borderClasses = 'ring-interactive-surface-filled-brand-default ring-2 ring-offset-2'

      return (
        <div className={'flex items-center space-x-2'}>
          <div className={'shrink-0'}>
            <span
              className={twMerge(
                borderClasses,
                'flex size-4 shrink-0 cursor-pointer items-center justify-center rounded-full border',
              )}
              aria-hidden={'true'}
            >
              <span className={'size-1.5 rounded-full bg-white'} />
            </span>
          </div>
          <span className={'min-w-0 flex-1'}>{label}</span>
        </div>
      )
    }}
  </HUIRadio>
)
